function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cs from 'classnames';
import { Icon } from '../../atoms/Icon/index';
/**
 * Status: *finished*.
 * Category: Links
 *
 * The target attribute is set to '_self' which is the default value if the attribute is not specified.
 * If you rather prefer to open the linked document in a new browser window or tab, you can set the target to '_blank' instead.
 *
 * Our links have _two visual means_ of being identified: an underline and bolder font.
 */

export var Link = function Link(props) {
  var className = props.className,
      text = props.text,
      children = props.children,
      href = props.href,
      iconPosition = props.iconPosition,
      _props$iconColor = props.iconColor,
      iconColor = _props$iconColor === void 0 ? 'core-purple' : _props$iconColor,
      negative = props.negative,
      _props$target = props.target,
      target = _props$target === void 0 ? undefined : _props$target,
      _props$type = props.type,
      type = _props$type === void 0 ? 'link' : _props$type,
      _props$inverted = props.inverted,
      inverted = _props$inverted === void 0 ? false : _props$inverted,
      rest = _objectWithoutProperties(props, ["className", "text", "children", "href", "iconPosition", "iconColor", "negative", "target", "type", "inverted"]);

  var icon; // Support for deprecated icons

  function checkForDeprecatedIcons() {
    if (props.icon === 'back-icon') return icon = 'arrow-left';
    if (props.icon === 'forward-icon') return icon = 'arrow-right';
    return icon = props.icon;
  }

  checkForDeprecatedIcons();

  if (type === 'bubble-link') {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: href,
      target: target
    }, rest, {
      className: "bubble-link bubble-link--".concat(iconColor).concat(inverted ? '-inverted' : '')
    }), /*#__PURE__*/React.createElement("div", {
      className: "bubble-link--flex-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "bubble-link--icon-circle\n              bubble-link--circle-background--".concat(iconColor).concat(inverted ? '-inverted' : '')
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      className: "bubble-link--icon bubble-link--icon-color--".concat(iconColor).concat(inverted ? '-inverted' : '')
    })), /*#__PURE__*/React.createElement("span", {
      className: "bubble-link--text"
    }, children)));
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    className: cs(negative ? 'link--negative' : 'link', icon && iconColor !== 'white' ? 'link--icon' : '', icon && iconColor === 'white' ? 'link--negative--icon' : '', className ? className : undefined),
    style: !icon ? {
      padding: 0
    } : {},
    href: href,
    target: target
  }, rest), icon && iconPosition === 'before' ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "link--icon--before link--".concat(iconColor === 'white' ? 'negative--' : '', "icon--").concat(iconColor)
  }) : null, text, children, icon && iconPosition === 'after' ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "link--icon--after link--".concat(iconColor === 'white' ? 'negative--' : '', "icon--").concat(iconColor)
  }) : null);
};
export default Link;